module.exports = __webpack_public_path__ + "src/assets/img/cmdPanicStop.29e6dd7c.svg";